/*
 * @Description: 修改日志组件
 */
import React from "react"
import _ from "lodash"
import { Table, Column, PageBar } from "@tencent/spaui"
import DateTime from "@/components/DateTime"
import { handleChangePart } from "@/utils/change-log"
import { CHANGE_LOG_TYPE } from "@/constants/Constants"

class ModifyLog extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      pageIndex: 0,
      pageSize: 20,
    }
    this.props.getModifyLogThis && this.props.getModifyLogThis(this)
  }

  getData = (pageSize, pageIndex) => {
    this.props.getData && this.props.getData({ pageSize, pageIndex })
  }

  initPage = () => {
    this.setState({
      pageIndex: 0,
      pageSize: 20,
    })
  }

  handleChangePageIndex = (event, value, pageSize) => {
    this.setState(
      {
        pageIndex: value - 1,
        pageSize,
      },
      () => {
        this.getData(pageSize, value - 1)
      }
    )
  }

  handleChangePageSize = (value, pageSize) => {
    this.setState(
      {
        pageIndex: value - 1,
        pageSize,
      },
      () => {
        this.getData(pageSize, value - 1)
      }
    )
  }

  handleParseJson = (string) => {
    let obj = {}
    try {
      obj = JSON.parse(string)
    } catch (error) {
      obj = {}
    }
    return obj
  }

  handleMapping = (filedMapping) => {
    const mapping = this.handleParseJson(filedMapping)
    const obj = {}
    mapping.map((v) => {
      return (obj[v.title] = v.column)
    })
    return obj
  }

  renderColumn = (type, name, value, data) => {
    if (type === "head") {
      return value
    }
    if (value) {
      const { type, filedMapping, beforeChange, afterChange } = data
      switch (name) {
        case "lastModTime":
          return <DateTime dateTime={value} />
        case "operationType":
          return CHANGE_LOG_TYPE[value] || value
        case "beforeChange":
          const before = this.handleParseJson(beforeChange)
          return handleChangePart(before, this.handleMapping(filedMapping))
        case "afterChange":
          const after = this.handleParseJson(afterChange)
          return handleChangePart(after, this.handleMapping(filedMapping))
        default:
          return ""
      }
    }
  }

  renderList = () => {
    const { pageIndex, pageSize } = this.state
    const { loading, data = {} } = this.props
    const { conf = {}, items = [] } = data
    return (
      <React.Fragment>
        <Table cssFixedTheadAble scrollTarget="body" setCssFixedTheadSpace={() => 40} data={items} loading={loading}>
          <Column name="lastModTime" render={this.renderColumn}>
            操作时间
          </Column>
          <Column name="operatorName">操作人</Column>
          <Column name="operationType" render={this.renderColumn}>
            操作类型
          </Column>
          <Column name="beforeChange" render={this.renderColumn}>
            原始值
          </Column>
          <Column name="afterChange" render={this.renderColumn}>
            变更值
          </Column>
        </Table>
        <PageBar value={pageIndex + 1} pageSize={pageSize} totalSize={conf?.totalCount || 0} pageSizeList={[10, 20, 50, 100, 200]} onChange={this.handleChangePageIndex} onPageSizeChange={this.handleChangePageSize} />
      </React.Fragment>
    )
  }

  render() {
    return this.renderList()
  }
}

export default ModifyLog
